import { Account } from 'containers/AccountManager'

export default Account
